/**
 * ============================================================================
 * DOGSTER BARF · Configuración de la Calculadora de Alimentación
 * ============================================================================
 * Este es el ÚNICO archivo que se debe tocar para actualizar precios,
 * porcentajes, descuentos, ciudades, recetas o razas. La lógica de cálculo
 * (barf-calculator.js) no debe modificarse para estos cambios.
 *
 * Fuente de verdad original: act_Calculadora_DOGSTER_2026.xlsx (hoja "Datos"
 * y hoja "Calculadora"). Los valores de abajo fueron extraídos línea por
 * línea de ese archivo el 18/jul/2026.
 *
 * ⚠️ Puntos marcados "REVISAR" son suposiciones o vacíos que el Excel no
 * definía y que Diego debe confirmar/ajustar.
 * ============================================================================
 */
window.DOGSTER_BARF_CONFIG = {

  // --------------------------------------------------------------------
  // Moneda y redondeo comercial
  // --------------------------------------------------------------------
  currency: 'COP',
  currencySymbol: '$',
  roundToNearest: 100,      // todos los precios se redondean a la centena (MROUND de Excel)
  portionGrams: 250,        // Dogster solo vende bolsas de 250 g

  // --------------------------------------------------------------------
  // Calculadora EMBEBIDA EN PRODUCTO (snippets/barf-calculator-product.liquid)
  // --------------------------------------------------------------------
  // En la página de producto, el precio de cada variante debe estar
  // configurado POR BOLSA de 250 g (activa "Precio unitario" en Shopify
  // para que se muestre el $/kg de referencia automáticamente). La venta
  // mínima es 1 kilo (4 bolsas); de ahí en adelante la cantidad sube de
  // bolsa en bolsa — nunca se fuerza a kilos completos.
  minSaleKg: 1,

  // WhatsApp y correo para gestionar suscripciones y pedidos sin producto
  // asignado. La calculadora embebida en producto no tiene panel de
  // ajustes propio (es un bloque "Liquid personalizado", sin schema), así
  // que estos valores se editan aquí directamente.
  contact: {
    whatsappNumber: '573002655281',
    email: 'contacto@dogsterbarf.com'
  },

  // --------------------------------------------------------------------
  // Descuentos por plan de compra (editable sin tocar lógica)
  // --------------------------------------------------------------------
  // Quincena y mes vienen del Excel y son fijos aquí. Los descuentos de
  // SUSCRIPCIÓN todavía no están definidos por el negocio, así que su
  // valor real NO se edita en este archivo: se configuran desde el editor
  // de temas de Shopify (Personalizar > esta sección > "Suscripciones"),
  // para poder ajustarlos sin tocar código. Los valores de abajo son solo
  // el respaldo si la sección no entrega esa configuración.
  // --------------------------------------------------------------------
  // Descuentos de las promociones (editable sin tocar lógica)
  // --------------------------------------------------------------------
  // Definidos directamente por Diego (no vienen del Excel):
  //   - 14 días (2 semanas): 2% de descuento
  //   - 28 días (4 semanas): 5% de descuento
  // Para cambiar el %, edita solo estos dos números (son fracciones:
  // 0.02 = 2%, 0.05 = 5%).
  discounts: {
    dias14: 0.02,
    dias28: 0.05
  },

  // --------------------------------------------------------------------
  // % de peso corporal a alimentar por día
  // Copiado exactamente de la hoja "Calculadora" (columna G) del Excel.
  // --------------------------------------------------------------------
  percentages: {
    perro: {
      adulto: {
        // tamaño -> { activa (SI), sedentaria (NO) }
        gigante: { activa: 0.025, sedentaria: 0.020 },
        grande:  { activa: 0.030, sedentaria: 0.025 },
        mediano: { activa: 0.035, sedentaria: 0.030 },
        pequeno: { activa: 0.040, sedentaria: 0.035 }
      },
      // cachorro no distingue tamaño ni actividad en el Excel
      cachorro: {
        '2-4': 0.070,
        '5-8': 0.050,
        '9-11': 0.035
      }
    },
    gato: {
      // el Excel no tiene columna de actividad física para gatos
      adulto: {
        mediano: 0.040,
        pequeno: 0.030
      },
      cachorro: {
        '2-4': 0.080,
        '5-8': 0.060,
        '9-11': 0.040
      }
    }
  },

  // --------------------------------------------------------------------
  // Rangos de peso que definen cada categoría de tamaño (kg)
  // --------------------------------------------------------------------
  sizeRanges: {
    perro: {
      pequeno: { min: 1,  max: 12,  label: 'Pequeño (1 a 12 kg)' },
      mediano: { min: 13, max: 25,  label: 'Mediano (13 a 25 kg)' },
      grande:  { min: 25, max: 40,  label: 'Grande (25 a 40 kg)' },
      gigante: { min: 40, max: 999, label: 'Gigante (más de 40 kg)' }
    },
    gato: {
      pequeno: { min: 1,  max: 12, label: 'Pequeño (1 a 12 kg)' },
      mediano: { min: 13, max: 25, label: 'Mediano (13 a 25 kg)' }
    }
  },

  // --------------------------------------------------------------------
  // Recetas disponibles (nombre EXACTO como aparece en el Excel / tienda)
  // --------------------------------------------------------------------
  recipes: {
    perro: [
      { id: 'mixta',          label: 'Clásica Mixta' },
      { id: 'carne',          label: 'Clásica de Carne' },
      { id: 'pollito',        label: 'Pollito' },
      { id: 'polloEspinaca',  label: 'Pollo Espinaca' },
      { id: 'polloPescado',   label: 'Pollo Pescado' },
      { id: 'bajaGrasa',      label: 'Baja en grasa' },
      { id: 'variadito',      label: 'Variadito (Mixta - Pollo - Pollo Espinaca)' }
    ],
    gato: [
      { id: 'gatosMixta', label: 'Mixta de Gatitos' }
    ]
  },

  // --------------------------------------------------------------------
  // Ciudades / zonas de precio
  // --------------------------------------------------------------------
  cities: [
    { id: 'tunja',  label: 'Tunja' },
    { id: 'bogota', label: 'Bogotá' },
    { id: 'chia', label: 'Chía' },
    { id: 'boyacaIntermunicipal', label: 'Boyacá Intermunicipal' }
  ],

  // --------------------------------------------------------------------
  // Precio por kilo, por ciudad y receta.
  // Tunja y Bogotá: valores exactos de la hoja "Datos" del Excel.
  // Chía y Boyacá Intermunicipal no existían en el Excel; por indicación
  // de Diego (18/jul/2026): Chía usa el mismo precio que Bogotá, y Boyacá
  // Intermunicipal usa el mismo precio que Tunja.
  // --------------------------------------------------------------------
  prices: (function () {
    const tunja = {
      mixta: 13800, carne: 16500, pollito: 13900, polloEspinaca: 14700,
      polloPescado: 17300, bajaGrasa: 17000, variadito: 11500, gatosMixta: 19000
    };
    const bogota = {
      mixta: 17000, carne: 19700, pollito: 17100, polloEspinaca: 17900,
      polloPescado: 20500, bajaGrasa: 20200, variadito: 14500, gatosMixta: 22200
    };
    return {
      tunja: tunja,
      bogota: bogota,
      chia: Object.assign({}, bogota),                 // mismo precio que Bogotá
      boyacaIntermunicipal: Object.assign({}, tunja)    // mismo precio que Tunja
    };
  })(),

  // --------------------------------------------------------------------
  // Razas → tamaño — SOLO RESPALDO.
  // La forma recomendada de agregar/quitar razas es desde el editor de
  // temas de Shopify: Personalizar > esta sección > bloques tipo "Raza".
  // Ahí puedes añadir o borrar razas sin tocar código. Esta lista de aquí
  // solo se usa si, por algún motivo, la sección no trae ningún bloque de
  // raza cargado (p. ej. pruebas locales fuera de Shopify).
  // --------------------------------------------------------------------
  breeds: {
    perro: [
      { name: 'Criollo / Mestizo — Pequeño', size: 'pequeno' },
      { name: 'Criollo / Mestizo — Mediano', size: 'mediano' },
      { name: 'Criollo / Mestizo — Grande', size: 'grande' },
      { name: 'Criollo / Mestizo — Gigante', size: 'gigante' },
      { name: 'Chihuahua', size: 'pequeno' },
      { name: 'French Poodle (Toy/Mini)', size: 'pequeno' },
      { name: 'French Poodle (Estándar)', size: 'mediano' },
      { name: 'Yorkshire Terrier', size: 'pequeno' },
      { name: 'Salchicha (Dachshund)', size: 'pequeno' },
      { name: 'Pug', size: 'pequeno' },
      { name: 'Maltés', size: 'pequeno' },
      { name: 'Pomerania', size: 'pequeno' },
      { name: 'Shih Tzu', size: 'pequeno' },
      { name: 'Beagle', size: 'mediano' },
      { name: 'Bulldog Francés', size: 'pequeno' },
      { name: 'Bulldog Inglés', size: 'mediano' },
      { name: 'Cocker Spaniel', size: 'mediano' },
      { name: 'Schnauzer Miniatura', size: 'pequeno' },
      { name: 'Schnauzer Estándar', size: 'mediano' },
      { name: 'Border Collie', size: 'mediano' },
      { name: 'Basset Hound', size: 'mediano' },
      { name: 'Boxer', size: 'grande' },
      { name: 'Labrador Retriever', size: 'grande' },
      { name: 'Golden Retriever', size: 'grande' },
      { name: 'Pastor Alemán', size: 'grande' },
      { name: 'Husky Siberiano', size: 'grande' },
      { name: 'Pastor Belga Malinois', size: 'grande' },
      { name: 'Doberman', size: 'grande' },
      { name: 'Dálmata', size: 'grande' },
      { name: 'Pitbull', size: 'grande' },
      { name: 'American Staffordshire Terrier', size: 'grande' },
      { name: 'Rottweiler', size: 'gigante' },
      { name: 'Gran Danés', size: 'gigante' },
      { name: 'San Bernardo', size: 'gigante' },
      { name: 'Mastín Napolitano', size: 'gigante' },
      { name: 'Dogo Argentino', size: 'gigante' },
      { name: 'Gran Pirineo', size: 'gigante' },
      { name: 'Terranova', size: 'gigante' },
      { name: 'Bóxer XL / cruce grande', size: 'gigante' }
    ],
    gato: [
      { name: 'Gato Criollo / Común', size: 'pequeno' },
      { name: 'Gato de raza grande (Maine Coon, etc.)', size: 'mediano' }
    ]
  }
};
